<template>
  <div class="form-field-container">
    <label v-if="showLabel" :for="id" :class="['form-label', { 'red-label': isRedLabel }]">{{ label }}</label>
    <div v-if="showRequired" class="required-mark-container">
      <span v-if="required" class="required-mark">必須</span>
    </div>
    <div class="number-container" :class="`number-container-${size}`">
      <div class="currency-symbol" v-if="isCurrency">¥</div>
      <input 
        type="number" 
        :id="id" 
        :name="id" 
        :class="computedInputClass" 
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @keydown="preventInvalidInput"
        :placeholder="placeholder"
        :disabled="disabled"
        :min="min"
        :max="max"
        :step="step"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormNumberField',
  props: {
    label: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: [Number, String],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showRequired: {
      type: Boolean,
      default: true
    },
    inputClass: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: [Number, String],
      default: null
    },
    max: {
      type: [Number, String],
      default: null
    },
    step: {
      type: [Number, String],
      default: 1
    },
    isCurrency: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'large',
      validator: value => ['small', 'medium', 'large'].includes(value)
    },
    isRedLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedInputClass() {
      return this.isCurrency ? `${this.inputClass} currency` : this.inputClass;
    }
  },

  methods: {
    preventInvalidInput(event) {
      // 'e', 'E', '+', '-' の入力を防止
      if (['e', 'E'].includes(event.key)) {
        event.preventDefault();
      }
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.form-field-container {
  display: flex;
  align-items: center;
  background-color: #FFF;
  padding: 10px 30px;
  margin: 5px;
  border-radius: 4px;
  width: auto; /* sizeプロパティで上書きされる */
}

.form-label {
  min-width: 180px;
  font-weight: 700;
  flex: 0 0 180px;
}

.form-label.red-label {
  color: #ff0000;
}

.required-mark-container {
  width: 40px;
  margin-right: 10px;
  flex-shrink: 0;
}

.required-mark {
  background-color: #ff0000;
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 12px;
  width: 100%;
  text-align: center;
  display: inline-block;
}

.number-container {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 200px;
}

.number-container-small {
  width: 200px;
}

.number-container-medium {
  width: 400px;
}

.number-container-large {
  flex: 1;
}

.currency-symbol {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 30px;
  background-color: #195983;
  color: white;
  font-weight: bold;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

input[type="number"] {
  width: 100%;
  padding: 8px;
  border: 2px solid #195983;
  border-radius: 4px;
  box-sizing: border-box;
}

input[type="number"].currency {
  padding-left: 30px; /* Make space for currency symbol */
}

/* Hide spinner buttons for number input */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
